import type { Locale } from '../i18n/locales';

interface DeployChipProps {
  locale: Locale;
}

export function DeployChip({ locale }: DeployChipProps): JSX.Element {
  return (
    <div className="deploy-chip">
      <span className="deploy-chip__badge" aria-hidden="true">
        →
      </span>
      <span>{locale.deployChip}</span>
    </div>
  );
}
